import { Currency, Language } from '../enums';
import { Address } from './address';
import { Order } from './order';

export interface MyProfile {
    loyaltyPlan: LoyaltyPlan;
    orders: Order[];
    layawayPlan: LayawayPlan;
    vouchers: Voucher[];
    addresses: Address[];
    currency: Currency;
    language: Language;
    notificationSettings: NotificationSettings;
    isPushRegistered: boolean;
    isPushSubscribed: boolean;
    pushDeviceIds: string[];
}

export interface LoyaltyPlan {}

export interface LayawayPlan {}

export interface Voucher {}

export interface NotificationSettings {
    pushNotificationsEnabled: boolean;
    emailNotificationsEnabled: boolean;
}
